import React from 'react'
import FastMultipleEntryInfo from './FastMultipleEntryInfo'

const FastMultiProductEntry = (props) => {
  const { productDetails, setAddItemsFromSideNav, setItemDetails } = props
  setAddItemsFromSideNav(true)

  return (
    <FastMultipleEntryInfo
      navigate={props.navigateToConfirm}
      productDetails={productDetails}
      setItemDetails={setItemDetails}
    />
  )
}

export default FastMultiProductEntry
